import { env } from "@/lib/env";

type GtagParams = Record<string, string | number | boolean | undefined>;
type GtagConsentParams = {
  analytics_storage: "granted" | "denied";
  ad_storage: "granted" | "denied";
  ad_user_data: "granted" | "denied";
  ad_personalization: "granted" | "denied";
  wait_for_update?: number;
};

type GtagCommand =
  | ["js", Date]
  | ["config", string, GtagParams?]
  | ["event", string, GtagParams?]
  | ["consent", "default" | "update", GtagConsentParams];

type GtagFunction = (...args: GtagCommand) => void;

declare global {
  interface Window {
    gtag?: GtagFunction;
    dataLayer?: unknown[][];
  }
}

type EventOptions = {
  category: string;
  action: string;
  label?: string;
  value?: number;
};

export function trackEvent({
  category,
  action,
  label,
  value,
}: EventOptions): void {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
      value,
    });
  }
}

export function trackPageView(url: string): void {
  if (typeof window !== "undefined" && window.gtag && env.NEXT_PUBLIC_GA_ID) {
    window.gtag("config", env.NEXT_PUBLIC_GA_ID, {
      page_path: url,
    });
  }
}

export function initializeAnalytics(): void {
  if (typeof window === "undefined" || !env.NEXT_PUBLIC_GA_ID) {
    return;
  }

  const dataLayer = window.dataLayer || [];

  const gtag: GtagFunction = (...args) => {
    dataLayer.push([...args]);
  };

  window.dataLayer = dataLayer;
  window.gtag = gtag;

  gtag("js", new Date());
  gtag("config", env.NEXT_PUBLIC_GA_ID, {
    send_page_view: false,
  });
}
